
import { createContext, useContext, ReactNode } from "react";
import { ResponseItem } from "@/components/resource/types";

export interface FreeResponseContextProps {
  responses: Record<string, string>;
  isSubmitting: boolean;
  isCompleted: boolean;
  isAdmin: boolean;
  attempt: any;
  handleResponseChange: (questionId: string, value: string) => void;
  handleSubmit: () => Promise<void>;
}

const FreeResponseContext = createContext<FreeResponseContextProps | undefined>(undefined);

export const FreeResponseProvider = ({ 
  children, 
  value 
}: { 
  children: ReactNode;
  value: FreeResponseContextProps;
}) => {
  return (
    <FreeResponseContext.Provider value={value}>
      {children}
    </FreeResponseContext.Provider>
  );
};

export const useFreeResponseContext = () => {
  const context = useContext(FreeResponseContext);
  if (!context) {
    throw new Error("useFreeResponseContext must be used within a FreeResponseProvider");
  }
  return context;
};
